import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children }) => (
  <p className="text-xs sm:text-sm uppercase tracking-[0.3em] font-mono text-gold-amber/90" data-testid="section-kicker">
    {children}
  </p>
);
